import {RequestedNotDeviceItemModel} from './requested-not-device-item.model';
import {DateTimeUtils} from '../utils/date-time.utils';

export class RequestedSupplyInfoModel {
    supplyDistributorId: number;
    secondarySupplyDistributorId: number;
    rolloutStart: Date;
    rolloutEnd: Date;
    timePeriodInMonths: number;
    requestedSupplies: RequestedNotDeviceItemModel[];


    public static fromJson(requestedSupplyInfo: any): RequestedSupplyInfoModel {
        if (requestedSupplyInfo) {
            requestedSupplyInfo.rolloutStart = DateTimeUtils.StringToDate(requestedSupplyInfo.rolloutStart);
            requestedSupplyInfo.rolloutEnd = DateTimeUtils.StringToDate(requestedSupplyInfo.rolloutEnd);

            return requestedSupplyInfo as RequestedSupplyInfoModel;
        }
        return requestedSupplyInfo;
    }

    public static toJson(requestedSupplyInfo: RequestedSupplyInfoModel): object {
        if (requestedSupplyInfo) {
            const newRequestedSupplyInfo: object = {...requestedSupplyInfo};
            newRequestedSupplyInfo['rolloutStart'] = DateTimeUtils.DateToRestString(requestedSupplyInfo.rolloutStart);
            newRequestedSupplyInfo['rolloutEnd'] = DateTimeUtils.DateToRestString(requestedSupplyInfo.rolloutEnd);
            newRequestedSupplyInfo['requestedSupplies'] =
                requestedSupplyInfo.requestedSupplies.map(rs => RequestedNotDeviceItemModel.toJson(rs));
            return newRequestedSupplyInfo;
        }
        return requestedSupplyInfo;
    }
}

